(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-desktop-navigation')) {
    customElements.define('pp-desktop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details = Array.from(this.querySelectorAll('.pp-nav__details'));
        this.timers = new Map();
        this.details.forEach(detail => {
          const summary = detail.querySelector('summary');
          summary.setAttribute('aria-expanded', String(detail.open));
          detail.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(detail.open));
            if (detail.open) {
              this.closest('header').querySelectorAll('.pp-nav__details[open]').forEach(other => {
                if (other !== detail) other.open = false;
              });
            }
          }, options);
          detail.addEventListener('keydown', event => {
            if (event.key === 'Escape' && detail.open) {
              event.preventDefault(); event.stopPropagation(); detail.open = false; summary.focus();
            }
          }, options);
          detail.addEventListener('focusout', event => {
            if (!detail.contains(event.relatedTarget)) detail.open = false;
          }, options);
          if (this.dataset.hover === 'true') {
            detail.addEventListener('pointerenter', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.timers.get(detail));
              this.timers.set(detail, setTimeout(() => { detail.open = true; }, 120));
            }, options);
            detail.addEventListener('pointerleave', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(this.timers.get(detail));
              this.timers.set(detail, setTimeout(() => {
                if (!detail.contains(document.activeElement)) detail.open = false;
              }, 180));
            }, options);
          }
        });
        document.addEventListener('click', event => {
          this.details.forEach(detail => {
            if (!detail.contains(event.target)) detail.open = false;
          });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort(); this.timers?.forEach(timer => clearTimeout(timer));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
